import React, { useEffect, useState, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";


const BranchPerformanceReport = ({ openBranchPerformanceReport, dateFrom, dateTo, selectedRegionIds, changeRegionIds, reportUrl }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [allreportsNew, setAllReportsNew] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const timeoutRef = useRef(null);


    const [dataTable, setDataTable] = useState({
        page: 0,
        size: 10,
        search: '',
        order: null,
    });

    const setTable = (tableState) => {
        setDataTable({
            page: tableState.page,
            search: tableState.searchText,
            size: tableState.rowsPerPage,
            order: tableState.sortOrder
        });
    };

    const columns = [
        {
            label: 'Branch',
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Date',
            name: 'issuedDate',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px' }}>{value}</p>
                )
            }
        },
        {
            label: 'Tickets Issued',
            name: 'issuedTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Tickets Transferred",
            name: 'transferredTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Tickets Served",
            name: 'servedTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Not Served",
            name: 'notServedTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Serving",
            name: 'servingTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Noshow",
            name: 'noShowTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Local Wait",
            name: 'localWaitingTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Avg Wait Time",
            name: 'averageWaitingTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Max Wait Time",
            name: 'maxWaitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Within Accepted wait Time",
            name: 'withinAcceptWaitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Service Level",
            name: 'waitTimeServiceLevel',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "AVG Service Time",
            name: 'averageServiceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Max Service Time",
            name: 'maxServiceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Within Accepted Service Time",
            name: 'withinAcceptServiceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Service Level",
            name: 'serviceTimeServiceLevel',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Overall Service Level (%)",
            name: 'overallServiceLevel',
            options: {
                sort: true,
                filter: false,
            }
        },


    ];

    const options = {
        // tableBodyHeight: '80vh',
        filterType: 'dropdown',
        filter: false,
        responsive: 'vertical',
        serverSide: true,
        count: count,
        download: false,
        jumpToPage: true,
        selectableRows: 'none',
        storageKey: '_br_bpr_table',
        print: false,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        onTableChange: (action, tableState) => {

            // a developer could react to change on an action basis or
            // examine the state as a whole and do whatever they want

            switch (action) {
                case 'changePage':
                    getBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'sort':
                    getBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    getBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'search':
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(() => getBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage), 2000);
                    setTable(tableState);
                    break;
                default:
                    break;
            }
        },
    };



    // when pick date, call  getBranchPerformanceReport function
    useEffect(() => {
        if (openBranchPerformanceReport) {
            if (dateFrom.length > 0 && dateTo.length > 0) {
                getBranchPerformanceReport(0, null, null, rowsPerPage);
            }
        }
    }, [openBranchPerformanceReport, dateFrom, dateTo])

    // when change selected region array, call getBranchPerformanceReport - useEffect
    useEffect(() => {
        if (openBranchPerformanceReport) {
            getBranchPerformanceReport(0, null, null, rowsPerPage);
        }
    }, [changeRegionIds])


    // getBranchPerformanceReport - function
    const getBranchPerformanceReport = (page, sortOrder, search, size) => {
        setIsLoading(true);

        axios({
            method: 'POST',
            url: `${reportUrl}/report-controller/get/branch-performance-data/paginated/customer/${userDetails.cid}`,
            headers: {
                Authorization: token
            },
            data: {
                "page": page,
                "size": size,
                "dateFrom": dateFrom,
                "dateTo": dateTo,
                "sort": sortOrder,
                "searchText": search,
                branchIds: selectedRegionIds
            }

        }).then((res) => {

            let data = res.data.data;

            setAllReportsNew((data.content))
            setCount(data.totalElements);
            setIsLoading(false);

        }).catch((error) => {
            console.log(error);
            setIsLoading(false);

            if (error.response !== undefined) {
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }


    return (
        <>
            <div><ToastContainer /></div>

            <MUIDataTable
                title={
                    <>
                        {isLoading ?
                            <CircularProgress color="secondary" size={20} /> : <>{count} records.</>}
                    </>
                }
                data={allreportsNew}
                columns={columns}
                options={options}
                className='text-center-table'
            />

        </>
    )
}

export default BranchPerformanceReport
